import React from 'react'
import { agoText, dateTimeText } from '../../../../../../shared/date/local-time'
import { useMinuteClock } from '../../../../../../shared/date/use-minute-clock'
import './node-updated.scss'

// A course or template card's last line (owner 2026-10-09): when a build of
// it last became available -- content's `publishedAt`, the latest of its
// platforms' current builds (api/ddd/common/coursebuild) -- as "Updated 5
// minutes ago"; with no build, when it was created ("Created yesterday").
// In the viewer's zone, the exact local time on hover ("Oct 9, 2026 at
// 11:20 AM MDT"); moves on once a minute (the page's one clock). Small and
// quiet, one line, cut with an ellipsis on a narrow card. Folders don't
// show it.
export const NodeUpdated = ({ node }) => {
  const now = useMinuteClock()
  const published = node?.publishedAt
  const at = published || node?.createdAt
  const ago = agoText(at, { now })
  if (!ago) return null

  return (
    <div className="node-updated text-truncate" title={dateTimeText(at)} data-testid="node-updated">
      <time dateTime={new Date(at).toISOString()}>
        {published ? 'Updated' : 'Created'} {ago}
      </time>
    </div>
  )
}
